/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import exciseService from './../../services/exciseEntry';
import debounce from 'debounce';
import SearchMixin from './../../mixins/search';
import exciseGroupService from './../../services/exciseGroup';
import additionalCodeSrvice from './../../services/additionalCode';
import helpers from './../../utils/helpers';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      entries: [],
      pagination: {},
      page: 1,
      limit: 5,
      flag : '',
    };
  },

  computed: {

  },

   props: {
    month: {
      type: [String],
      required: true,
    },
  },

  components: {
    VCard: require('./../../components/card/card.vue'),
    VPagination: require('./../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../components/noData/noData.vue'),
    VTable: require('./../../components/table/table.vue'),
    VExciseTable: require('./../../components/exciseTable/exciseTable.vue'),
  },

  mixins: [
    SearchMixin,
  ],

  mounted() {
    
    
    const params = {
      page: 1,
      limit: 5,
      month: this.month,
      flag: true,
    };
   Promise.all([
      exciseService.entries(params),
      exciseGroupService.packaging(),
      exciseGroupService.basic(),
      exciseGroupService.all(),
      additionalCodeSrvice.all(),
    ]).then((data) => {
      console.log(data);
      this.entries = data[0].report;
      this.pagination = data[0].pagination;
      this.loading = false;
    });
  },

  methods: {
    
    /**
     * Fetches paginated warehouse.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all : debounce( function(page, limit) {
        
        this.page = page;
        this.limit = limit;
        this.loading = true;
        exciseService.entries({
          page,
          limit,
          month: this.month,
          flag: true,
        }).then((data) => {
          this.entries = data.report;
          this.pagination = data.pagination;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
    },800),

    updateList(index, data) {
      //this.entries[index] = data;
      //console.log(this.entries);

      this.all(this.page, this.limit);
    },

    changeData() {
      this.all(this.page, this.limit);
    },

    openLink(row, key) {

      if(row.excisable == 'order') {
        this.$router.push({
          name: 'orders.edit',
          params: { id: row.excisableId },
        });
      }else if(row.excisable == 'creditnote'){
        this.$router.push({
          name: 'bills.creditNote',
          params: { id: row.excisableId },
        });
      }else{
        this.$router.push({
          name: 'inventory.purchase.view',
          params: { id: row.excisableId },
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/exciseEntryModal/exciseEntryModal.js